module.exports = __webpack_public_path__ + "static/media/get-started.7f45b6c0.svg";